import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { SharedService } from 'src/app/shared/services/shared.service';

export const googlemapsInitializerResolver: ResolveFn<boolean> = (route, state) => {
  const sharedService = inject(SharedService);
  return sharedService.getGoogleAPIKey().pipe(
    map(() => true),
    catchError(error => {
      console.error('Error during google maps initialization: ', error);
      return of(false);
    }),
  );
};
